import React, { useEffect, useState, useRef } from 'react';
import { Game, Player } from '../../types/types';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import { useAppSelector, useAppDispatch } from '../../hooks';
import RemoveIcon from '@mui/icons-material/Remove';
import { TogglePlayerDisplay, selectPlayerDisplay} from '../../state/reducers/UserSettingsReducer';
import {CalculatePlayerStats} from '../../globals/Functions';
import { RemovePlayer } from '../../state/reducers/ChosenPlayersReducer';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import SelectedPlayersCards from '../Cards/SelectedPlayersCards';
import { TeamLogos, TeamsList } from '../../globals/Globals';
import { RenderPriceCell, RenderTeamCell } from '../../globals/TableFunctions';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';

export interface Props {
    players: Player[];
    setOpen: (setopen: boolean) => void;
}

const columns:GridColDef[]  = [
    { field: 'name', headerName: 'Name', width: 180 },
    { field: 'team', headerName: 'Team', width: 160,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCell(params.row.teamname, params.row.teamlogo, params.row.teamcolors))
    },
    { field: 'price', headerName: 'Price', width: 180,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderPriceCell(params.row.price, params.row.pricechange))
    },
    {field: "batSR", headerName: "Bat SR", type: "number"},
    {field: "bwlSR", headerName: "Bwl SR", type: "number"},
    {field: "three", headerName: "3rd Avg", type: "number"},
    {field: "five", headerName: "5rd Avg", type: "number"},
    { field: 'removebutton', headerName: '' ,renderCell: (params: GridRenderCellParams<Date>) => (
        <RemoveIcon />)
    },
    { field: 'viewbutton', headerName: '' ,renderCell: (params: GridRenderCellParams<Date>) => (
        <InfoIcon />)
    },
];

function SelectedPlayersTable({players, setOpen}:Props) {
    let router = useNavigate();
    const dispatch = useAppDispatch();
    
    let statePlayerDisplay = useAppSelector(selectPlayerDisplay);
    const [ rows, setRows ] = useState<object[]>([]);
    const [ height, setHeight ] = useState("200px");
    
    const onCellClick = (params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        
        if (params.field !== 'removebutton') {
            if (params.field === 'name' || params.field === 'viewbutton') {
                router('/player/'+params.row.id);
                setOpen(false);
            }
            
        } else {
            dispatch(RemovePlayer(params.row.id));
        }
    }


    const PopulateRows = () => {
        var newrows:object[] = [];
        players.map(function(player,index) {
            if (player) {
                if (player.stats) {

                
                    if (player?.stats[0]?.lastgame) {
                        var lastgame:Game = player.stats[0].lastgame;
                        var playerstats = CalculatePlayerStats({games: [lastgame]});
                        let increase:boolean = lastgame.price_change > 0;
                        let teamname = lastgame.team?.name ? lastgame.team?.name : '';
                        let teamcolors:string[] = TeamsList[teamname];
                        let pricechange = lastgame.price_change;
                        if (!teamcolors) {
                            teamcolors = ['', ''];
                        }
                        console.log("The Player: ", player);
                        //var position = player.stats[0].last5Games[0].position;
                        newrows.push({
                            id: player.id,
                            img: 'https://www.nrlsupercoachstats.com/highcharts/PlayerPictures/2021/Trbojevic,%20Tom.png',
                            name: `${player.firstname} ${player.lastname}`,
                            team: teamname,
                            five: playerstats.five,
                            three: playerstats.three,
                            teamlogo: TeamLogos[teamname],
                            priceincrease: increase,
                            teamname: teamname,
                            teamcolors: teamcolors,
                            pricechange: pricechange,
                            batSR: player.batStrikeStat.avgSR,
                            bwlSR: player.bwlStrikeStat.avgSR,
                            ...playerstats
                        });
                    }
                }
            }
            
        });
        setRows(newrows);
        setHeight(`${(players.length * 38) + 150}px`)
    }    
    useEffect(() => {
        PopulateRows();
    }, [players]);
    
    if (statePlayerDisplay === 'table') {
        return <PlayerDataGrid height={height} columns={columns} rows={rows} onCellClick={onCellClick} />
    } else {
        return <SelectedPlayersCards players={players} />
    }
    
    

}

export default SelectedPlayersTable;